import { Button, Image } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { ChooseFeatureTypeModal } from '@hero/components/organisms';
import { configs } from '@hero/configs';
import { OnboardingCard } from '@hero/molecules';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetUser } from '@hero/services/organization-service/hooks';
import { useOnboardingStore } from '@hero/store/hooks';

import * as S from './style';

function WelcomeCard({ isOnboardingCardShown, setIsOnboardingCardShown }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { data: user } = useGetUser();
  const { recognition } = useOnboardingStore();

  const [isSendGiftModalOpen, setIsSendGiftModalOpen] = useState(false);

  function handleCreate() {
    if (configs?.general?.simplifyFlow && !user?.meta?.isPunchoutUser) {
      navigate(ROUTE_PATHS.SEND_GIFT_OCCASIONS);
    } else {
      setIsSendGiftModalOpen(true);
    }
  }

  return (
    <S.Welcome>
      <Image src={theme.images.welcome} alt="Welcome to dashboard" height={160} />
      <S.WelcomeDescription variant="body1">{t('welcomeDescription')}</S.WelcomeDescription>
      <Button onClick={handleCreate}>{t('sendGifts')}</Button>

      <ChooseFeatureTypeModal
        isOpen={isSendGiftModalOpen}
        onClose={() => {
          setIsSendGiftModalOpen(false);
        }}
      />
      <OnboardingCard
        styles={{
          wrapper: {
            right: 24,
            bottom: 48
          }
        }}
        cardOffset={[16, 24]}
        position="left-start"
        isInfoActive={recognition?.infoCardsActive}
        isCardShown={isOnboardingCardShown}
        setIsCardShown={setIsOnboardingCardShown}
        title={t('createNewRecognition')}
        description={t('clickToCreateAndNameNewRecognition')}
        featureType="recognition"
      />
    </S.Welcome>
  );
}

export { WelcomeCard };
